import { UnionAlloyEvaluationType } from "./AlloyEvaluationSummary";

export function getEvaluationTagsHeader(evaluation: UnionAlloyEvaluationType) {
  return getEvaluationTitle(evaluation) + getEvaluationTagsSubtitle(evaluation);
}

export function getEvaluationOutcomeHeader(evaluation: UnionAlloyEvaluationType) {
  return getEvaluationTitle(evaluation) + getEvaluationOutcomesSubtitle(evaluation);
}

export function getEvaluationTitle(evaluation: UnionAlloyEvaluationType) {
  switch (evaluation.outcome) {
    case "Accepted":
      return "device_id" in evaluation ? "Approved" : "Transfer approved";
    case "Review":
      return "Review required";
    case "Declined":
      return "Transfer rejected";
    case "Blocked":
      return "Blocked";
    case "Blocked and locked":
      return "Blocked and locked";
    default:
      return "Alloy evaluation";
  }
}

function getEvaluationTagsSubtitle(evaluation: UnionAlloyEvaluationType) {
  switch (evaluation.tags.length) {
    case 0:
      return "";
    case 1:
      return `: ${evaluation.tags[0]}`;
    default:
      return `: ${evaluation.tags.length} tags`;
  }
}

function getEvaluationOutcomesSubtitle(evaluation: UnionAlloyEvaluationType) {
  switch (evaluation.outcome_reasons.length) {
    case 0:
      return "";
    case 1:
      return `: ${evaluation.outcome_reasons[0]}`;
    default:
      return `: ${evaluation.outcome_reasons.length} outcome reasons`;
  }
}
